import React from 'react';
import { Statement } from '@/customTypes/chatStory';
import TimerBar from '../TimerBar';

interface IChoiceTimer {
  choice?: Statement;
  onChoice: ({
    choiceName,
    choiceItem,
    choiceUserInput,
  }: {
    choiceName: string;
    choiceItem?: {
      choiceIndex: number;
      selectedName: string;
    };
    choiceUserInput?: {
      leftUserInputText?: string | undefined;
      rightUserInputText?: string | undefined;
    };
  }) => void;
}

const ChoiceTimer = ({ choice, onChoice }: IChoiceTimer) => {
  if (
    choice &&
    choice.options?.layoutType !== 'UserInputChoice' &&
    choice.options?.timeout !== -1
  ) {
    return (
      <TimerBar
        timeout={choice?.options?.timeout}
        onClear={() => {
          const choiceLength = choice.choices?.length || 0;
          const selectIndex = Math.floor(Math.random() * choiceLength);
          onChoice({
            choiceName: choice.choiceName || '',
            choiceItem: {
              choiceIndex: selectIndex,
              selectedName: choice.choices[selectIndex],
            },
          });
        }}
      />
    );
  } else {
    return null;
  }
};

export default ChoiceTimer;
